<div class="media-container">
  @if (url){
    <!-- Standalone /preview page: url is populated from ?imageUrl query param -->
    <dal-shared-ui-media-renderer [url]="url" [type]="getMediaType()" [imagePreview]="true" [applyClass]="false"></dal-shared-ui-media-renderer>
  }
  @for (media of mediaFiles; track media) {
    <dal-shared-ui-media-renderer [url]="media.url" [type]="getMediaType()" [imagePreview]="false" [applyClass]="false"></dal-shared-ui-media-renderer>
    @if (!url){
      <!-- Embedded mode: url is not set, so show the "open in new tab" affordance -->
      <div class="preview-link" (click)="openImageInNewTab(media.url)">
        <span class="preview-icon">
          <i class="fas fa-external-link-alt"></i>
        </span>
      </div>
    }
  }
</div>
